import {
	FaBootstrap,
	FaCss3Alt,
	FaGithub,
	FaHtml5,
	FaReact,
	FaAndroid,
	FaJava,
	FaPython,
	FaBrain
} from "react-icons/fa";
import { DiJavascript1, DiMsqlServer } from "react-icons/di";
import { VscJson } from "react-icons/vsc";
import {
	SiSwagger,
	SiApachekafka,
	SiMariadb,
	SiDjango,
	SiPandas,
	SiAmazonaws,
	SiJquery,
	SiPlotly,
	SiJira,
	SiFlask,
} from "react-icons/si";

export const SkillsData = [
	{
		name: "Java",
		icon: <FaJava />,
	},
	{
		name: "Python",
		icon: <FaPython />,
	},
	{
		name: "MSSql",
		icon: <DiMsqlServer />,
	},
	{
		name: "AI/ML",
		icon: <FaBrain />,
	},
	{
		name: "HTML",
		icon: <FaHtml5 />,
	},
	{
		name: "CSS",
		icon: <FaCss3Alt />,
	},
	{
		name: "Javascript",
		icon: <DiJavascript1 />,
	},
	{
		name: "Django",
		icon: <SiDjango />,
	},
	{
		name: "RESTful Api",
		icon: <SiSwagger />,
	},
	{
		name: "Pandas",
		icon: <SiPandas />,
	},
	{
		name: "MariaDB",
		icon: <SiMariadb />,
	},
	{
		name: "Flask",
		icon: <SiFlask />,
	},
	{
		name: "Java Server Pages",
		icon: <FaJava />,
	},
	{
		name: "AWS",
		icon: <SiAmazonaws />,
	},
	{
		name: "React Js",
		icon: <FaReact />,
	},
	{
		name: "Bootstrap",
		icon: <FaBootstrap />,
	},
	{
		name: "JQuery",
		icon: <SiJquery />,
	},
	{
		name: "JSON",
		icon: <VscJson />,
	},
	{
		name: "Plotly",
		icon: <SiPlotly />,
	},
	{
		name: "Git",
		icon: <FaGithub />,
	},
	{
		name: "Jira",
		icon: <SiJira />,
	},
	{
		name: "Apache Kafka",
		icon: <SiApachekafka />,
	},
	{
		name: "Android",
		icon: <FaAndroid/>,
	},
];
